/*eslint-disable */

import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
// You need a specific loader for CSS files
Vue.component('multiselect', Multiselect)
export default {
  name: 'update-webinar-details',
  components: {
    datetime: Datetime,
    Multiselect,
  },
  props: [
    'updateWebinarID'
  ],
  data () {
    return {
      userProfileDetails:{},
      start_time:'',
      end_time:'',
      topic:'',
      users:{
        first_name:'',
        last_name:'',
        email:'',
        id:''
      },
      userList:{},
      userListResults:[],
      options:[],
      submitted:false,
      sentUserData:[],
      file:null,
      selectedFile:'',
      uploadAttachmentName:'',
      max_webinar_attendance:'',
      selfUserId:'',
      is_superuser:false,
      is_public:false,
      minDatetime:new Date().toISOString()
    }
  },
  computed: {
    ...mapGetters([
      'getAllUserListGetters',
      'acUserDetailsStateGetters'
    ]),
    getUserDetailsInfo(){
      this.userProfileDetails = this.$store.getters.acUserDetailsStateGetters.data;
      return
    },
    checkTheSelfUserStatus(){
        if(this.userProfileDetails){
          if(this.userProfileDetails.is_superuser === true){
            this.is_superuser = true
          }else{
            this.is_superuser = false
          }
        }
    },
    getUserList() {
      this.userList = this.$store.getters.getAllUserListGetters.data
      return this.userList
    },
    setIntialsState(){
      if(this.userList != undefined){
        this.userListResults = this.userList
        for(var i = 0; i < this.userListResults.length; i++){
          this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
        }
      }
    }
  },
  mounted () {
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    this.$store.dispatch('getWebinarDetailsByIdFun', {id:this.updateWebinarID}).then((res)=>{
      this.start_time = res.data.data.start_time
      this.end_time = res.data.data.end_time
      this.topic = res.data.data.topic
      this.is_public = res.data.data.is_public
      this.max_webinar_attendance = res.data.data.max_webinar_attendance
      this.selectedFile = res.data.data.attachment
      this.uploadAttachmentName = res.data.data.filename
      for(var i = 0; i < res.data.data.users.length; i++){
        this.users.first_name = res.data.data.users[i].user.first_name
        this.users.last_name = res.data.data.users[i].user.last_name
        this.users.email = res.data.data.users[i].user.email
        this.users.id = res.data.data.users[i].user.id
      }
    })
    this.getUserList
    this.setIntialsState
    this.setIntialsState
    this.checkTheSelfUserStatus
  },
  methods: {
    updateEndTime() {
      if(this.start_time){
        const originalDate = this.start_time;
        const date = new Date(originalDate);
        date.setHours(date.getHours() + 1);
        const newDate = date.toISOString();
        this.end_time = newDate;
      }
    },
    handleAttachmentUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      }else {
        this.file = null
        this.uploadAttachmentName = '';
      }
    },
    getWebinarListAgain(){
      this.$store.dispatch('getWebinarAllListFun').then((res)=>{
      })
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.users.push(tag) 
    },
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    updateWebinarBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var sendSpeakerId;
          if(this.is_superuser){
            sendSpeakerId = this.users.id
          }else{
            sendSpeakerId = this.selfUserId
          }
          let data = {
            topic:this.topic,
            start_time:this.start_time,
            is_public:this.is_public,
            end_time:this.end_time,
            users:[sendSpeakerId],
            is_webinar:true,
            is_active:this.is_public || false,
            max_webinar_attendance:this.max_webinar_attendance
          }
          this.$store.dispatch('updateWebinarDetailsByIdFun',{data:{data:data,id:this.updateWebinarID}})
            .then((res) => {  
              if(this.file != null){
                var formData = new FormData();
                formData.append('attachment', this.file);
                formData.append('filename', this.uploadAttachmentName);
                this.$store.dispatch('updateWebinarDetailsByIdFun', {data:{data:formData,id:this.updateWebinarID}}).then((res) => {
                  toast.success(res.data.msg);
                  this.getWebinarListAgain()
                  this.closeUpdateMeetingPopup()
                  this.submitted =  false
                }).catch((err)=>{
                  this.submitted =  false
                  toast.error(err.data.msg);
                })
              }else{
                toast.success(res.data.msg);
                this.getWebinarListAgain()
                this.closeUpdateMeetingPopup()
                this.submitted =  false
              }
            }).catch((err) => {
              toast.error(err.data.data.email || err.data.user_msg || err.data.msg);
              this.submitted =  false
            })
          return;
        }
      })
    },
    closeUpdateMeetingPopup(){
      bus.$emit('updateWebinarPopupBus', false);
      $('body').removeClass('body_right_scroll_remove')
    },
  },
  watch: {
    getUserDetailsInfo(){
      return this.$store.getters.acUserDetailsStateGetters
    },
    getUserList() {
      return this.$store.getters.getAllUserListGetters.data
    },
    userList(old_val, new_val){
      if(new_val == undefined){
          this.userListResults = old_val
          for(var i = 0; i < this.userListResults.length; i++){
            this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
          }
      }
    },
  },
}